import { __awaiter } from "tslib";
export function createXHR() {
    try {
        return new XMLHttpRequest();
    }
    catch (_a) {
        try {
            return new ActiveXObject('Msxml2.XMLHTTP');
        }
        catch (_b) {
            return new ActiveXObject('Microsoft.XMLHTTP');
        }
    }
    throw new Error('No xhr object');
}
export function loadXHR(url, responseType = '', onprogress) {
    return new Promise((resolve, reject) => {
        const xhr = createXHR();
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4)
                return;
            if (xhr.status !== 200) {
                reject(new Error(`Wrong response: ${xhr.status} ${url}`));
                return;
            }
            onprogress === null || onprogress === void 0 ? void 0 : onprogress(1.0);
            resolve(xhr);
        };
        xhr.onerror = (e) => {
            reject(new Error(`XHR error: ${url}`));
        };
        xhr.onprogress = (e) => {
            const progress = (e.total > 0 && e.loaded > 0)
                ? e.loaded / e.total
                : 0;
            onprogress === null || onprogress === void 0 ? void 0 : onprogress(progress);
        };
        xhr.open('GET', url, true);
        xhr.responseType = responseType;
        try {
            xhr.send();
        }
        catch (e) {
            reject(e);
        }
    });
}
export function loadArrayBuffer(url) {
    return loadXHR(url, 'arraybuffer')
        .then((xhr) => xhr.response);
}
export function loadJSON(url, onprogress) {
    return loadXHR(url, '', onprogress)
        .then((xhr) => JSON.parse(xhr.responseText));
}
export function loadBase64(url) {
    return loadArrayBuffer(url)
        .then((buffer) => buffer2base64(buffer));
}
export function buffer2base64(buffer) {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.length;
    for (let i = 0; i < len; i++)
        binary += String.fromCharCode(bytes[i]);
    return btoa(binary);
}
export function loadJS(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.onerror = (event) => {
            reject(new Error(`Failed to loadJS: ${url}`));
        };
        script.onload = resolve;
        script.src = url;
        script.type = 'text/javascript';
        document.head.appendChild(script);
    });
}
export function loadCSS(url) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('link');
        script.href = url;
        script.onerror = (event) => {
            console.error(`Failed to loadCSS ${url}`);
            reject(new Error(`Failed to loadCSS`));
        };
        script.onload = resolve;
        script.rel = 'stylesheet';
        script.type = 'text/css';
        document.head.appendChild(script);
    });
}
export function postFormData(url_1, data_1) {
    return __awaiter(this, arguments, void 0, function* (url, data, responseType = '') {
        const fd = new FormData();
        for (const k in data)
            fd.append(k, data[k]);
        return yield postBlob(url, fd, responseType);
    });
}
export function postBlob(url, blob, responseType = '') {
    return new Promise((resolve, reject) => {
        const xhr = createXHR();
        xhr.onreadystatechange = () => {
            if (xhr.readyState !== 4)
                return;
            if (xhr.status !== 200) {
                reject(new Error(`Wrong response: ${xhr.status} ${url}`));
                return;
            }
            resolve(xhr);
        };
        xhr.onload = () => {
            if (xhr.status !== 200) {
                reject(new Error(`Wrong response: ${xhr.status} ${url}`));
                return;
            }
            resolve(xhr);
        };
        xhr.onerror = reject;
        xhr.open('POST', url, true);
        xhr.responseType = responseType;
        xhr.send(blob);
    });
}
